import React from 'react';
import { Trans } from '@lingui/macro';
import { Text, Box, Chip, useBreakpoint } from '@landr/maestro';
import { useLingui } from '@lingui/react';
import { FiltersParams } from 'types/params';
import { ModifiersPayload } from 'controllers/SearchController/types';
import { FirstLevelItemObject } from 'components/Filters/context/FiltersContext/types';
import { useFilterState } from '../../FilterPanes/components/useFilterState';
import { chipStyles } from './styled';

interface FamilyFilterProps {
    filterType: FiltersParams;
    activeFilters: string[];
    filters: FirstLevelItemObject[];
    totalNumberOfResults: number;
    addFilter: (modifiers: ModifiersPayload[]) => void;
    removeFilter: (modifiers: ModifiersPayload[]) => void;
}

export const FamilyFilters: React.FC<FamilyFilterProps> = ({
    filterType,
    activeFilters,
    filters,
    totalNumberOfResults,
    addFilter,
    removeFilter,
}) => {
    const { i18n } = useLingui();
    const smallDesktop = useBreakpoint('lg');
    const { isFilterChecked, isFilterDisabled, toggleFilter } = useFilterState({
        filterType,
        activeFilters,
        totalNumberOfResults,
        addFilter,
        removeFilter,
    });

    const chipArray: Array<string> = [];

    filters.forEach((filter) => {
        chipArray.push(filter.code);
    });

    const handleClick = (value: any): void => {
        toggleFilter(value);
    };

    return (
        <Box mb="md">
            <Text
                display="inline-block"
                textTransform="uppercase"
                textStyle="body-sm"
                color="text.medium"
                mb="sm"
            >
                <Trans>Family</Trans>
            </Text>
            <Box
                display="grid"
                gridTemplateColumns={
                    !smallDesktop ? '1fr 1fr 1fr 1fr' : '1fr 1fr'
                }
                gridGap="xs"
            >
                {filters.map((filter) => {
                    const isChecked = isFilterChecked(filter.code);

                    return (
                        <Chip
                            cursor={
                                isFilterDisabled(filter)
                                    ? 'not-allowed'
                                    : 'pointer'
                            }
                            onClick={() => {
                                !isFilterDisabled(filter) &&
                                    handleClick(filter.code);
                            }}
                            palette="subtle"
                            key={filter.code}
                            isChecked={isChecked}
                            isDisabled={isFilterDisabled(filter)}
                            size="sm"
                            className={chipStyles({
                                isDisabled: isFilterDisabled(filter),
                            })}
                        >
                            {i18n._(filter.code)}
                        </Chip>
                    );
                })}
            </Box>
        </Box>
    );
};

export default FamilyFilters;
